module.exports = __webpack_public_path__ + "img/9.0994e7c6.png";